export default "__VITE_PUBLIC_ASSET__efdaf11d__"